<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">Born in Scotland but brought up in Ghana, Alexander did an MA Hons at the University of Edinburgh in Politics and Philosophy, followed by an MA in German and a doctorate at the University of West Berlin. Turning his back on the academic life, he produced 27 plays, five films and several documentaries.</p><br/>
<p style="text-indent:0em">After the fall of the Berlin wall, Alexander moved to Paris, and now works as an author and music producer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?39b8fb3c